package fr.manyverse.app.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Instant

/**
 * Represents an active timer.
 */
@Serializable
data class ActiveTimer(
    @SerialName("id")
    val id: String,

    @SerialName("table_id")
    val tableId: String,

    @SerialName("duration_seconds")
    val durationSeconds: Int,

    @SerialName("target_participants")
    val targetParticipants: List<String>,

    @SerialName("created_by")
    val createdBy: String,

    @SerialName("is_active")
    val isActive: Boolean,

    @SerialName("created_at")
    val createdAt: Instant,

    /** Non-null while the GM has paused the timer. */
    @SerialName("paused_at")
    val pausedAt: Instant? = null,

    /** Total duration of the completed pauses. */
    @SerialName("paused_seconds")
    val pausedSeconds: Int = 0
) {
    val isPaused: Boolean get() = pausedAt != null

    /**
     * Remaining seconds at [now], frozen at [pausedAt] while paused.
     */
    fun remainingSecondsAt(now: Instant): Int {
        val reference = pausedAt ?: now
        val elapsed = (reference - createdAt).inWholeSeconds.toInt() - pausedSeconds
        return (durationSeconds - elapsed).coerceAtLeast(0)
    }
}
